// src/AssociateAccountModal.js

import React, { useState } from 'react';

export function AssociateAccountModal({ personName, existingStaff = [], onConfirmNew, onConfirmExisting, onClose, isSubmitting = false }) {
    // 🎯 FIX: la modalità "account esistente" ha senso solo dove viene
    // esplicitamente supportata (oggi: solo ManageDoctors.js) — se il
    // chiamante non passa onConfirmExisting, la nascondiamo del tutto
    // invece di mostrare un bottone che poi andrebbe in crash al click.
    const supportsExisting = typeof onConfirmExisting === 'function';
    const [mode, setMode] = useState('new'); // 'new' | 'existing'
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [selectedUid, setSelectedUid] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const handleConfirm = () => {
        if (mode === 'new' || !supportsExisting) {
            if (!email || !password) {
                alert("Email e password sono obbligatori.");
                return;
            }
            onConfirmNew(email, password);
        } else {
            if (!selectedUid) {
                alert("Seleziona un account esistente dalla lista.");
                return;
            }
            onConfirmExisting(selectedUid);
        }
    };

    const filteredStaff = existingStaff.filter(s => {
        const term = searchTerm.toLowerCase();
        const name = (s.name || `${s.personalData?.firstName || ''} ${s.personalData?.lastName || ''}`).toLowerCase();
        return name.includes(term) || (s.email || '').toLowerCase().includes(term);
    });

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()}>
                <h3>Associa Account per {personName}</h3>

                {/* Selettore modalità — visibile solo se il chiamante supporta anche l'associazione a un account esistente */}
                {supportsExisting && (
                    <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                        <button
                            type="button"
                            onClick={() => setMode('new')}
                            className={mode === 'new' ? 'modal-button confirm-button' : 'modal-button cancel-button'}
                            style={{ flex: 1 }}
                        >
                            Crea Nuovo Account
                        </button>
                        <button
                            type="button"
                            onClick={() => setMode('existing')}
                            className={mode === 'existing' ? 'modal-button confirm-button' : 'modal-button cancel-button'}
                            style={{ flex: 1 }}
                        >
                            Associa Account Esistente
                        </button>
                    </div>
                )}

                {(mode === 'new' || !supportsExisting) ? (
                    <div style={{ textAlign: 'left', marginTop: '15px', display: 'grid', gap: '15px' }}>
                        <div>
                            <label htmlFor="user-email">Email</label>
                            <input id="user-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div>
                            <label htmlFor="user-password">Password</label>
                            <input id="user-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: 'left', marginTop: '15px' }}>
                        <p style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: '10px' }}>
                            Usa questa opzione se la persona ha già un account in questo centro
                            (es. è anche Proprietario o Segreteria): nessun nuovo login viene creato,
                            il suo ruolo e i suoi permessi attuali restano invariati — diventerà
                            in più selezionabile come medico in agenda.
                        </p>
                        <input
                            type="text"
                            placeholder="Cerca per nome o email..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '100%', boxSizing: 'border-box', marginBottom: '10px' }}
                        />
                        <div style={{ maxHeight: '220px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '5px' }}>
                            {filteredStaff.length === 0 && (
                                <p style={{ padding: '10px', color: '#94a3b8', fontSize: '0.85rem', margin: 0 }}>Nessun account trovato.</p>
                            )}
                            {filteredStaff.map(s => (
                                <label key={s.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}>
                                    <input
                                        type="radio"
                                        name="existing-account"
                                        checked={selectedUid === s.id}
                                        onChange={() => setSelectedUid(s.id)}
                                    />
                                    <span>
                                        {s.name || `${s.personalData?.firstName || ''} ${s.personalData?.lastName || ''}`.trim()}
                                        {' '}
                                        <span style={{ color: '#94a3b8' }}>({s.role}{s.email ? ` — ${s.email}` : ''})</span>
                                    </span>
                                </label>
                            ))}
                        </div>
                    </div>
                )}

                <div>
                    {/* 🐛 FIX: disabilitato mentre la creazione è in corso — impedisce
                        all'operatore di ricliccare pensando che il primo click non sia
                        partito, che è esattamente come si è generato il doppio account. */}
                    <button
                        onClick={handleConfirm}
                        disabled={isSubmitting}
                        className="modal-button confirm-button"
                        style={{ marginTop: '20px', opacity: isSubmitting ? 0.6 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
                    >
                        {isSubmitting ? 'Creazione in corso...' : ((mode === 'new' || !supportsExisting) ? 'Crea e Associa' : 'Associa')}
                    </button>
                    <button onClick={onClose} disabled={isSubmitting} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
}